const productFilters = {
  oFilterForm: null,
  aFilterGroups: null,
  aFilterInputs: null,
  aFilterCheckboxes: null,
  aFilterSelects: null,
  aFilterHiddenInputs: null,
  oFilterResults: null,
  aProducts: null,
  oPagingButtons: null,
  oShowAllResultsButton: null,
  aClearFilterButton: null,
  oClearAllFiltersButton: null,
  oSliders: null,
  oMobileFilterToggles: null,
  oMobileFilters: null,
  oMobileFiltersListItems: null,
  oMobileFiltersLevelBack: null,
  aCreatedSliders: [],
  oAjaxTrigger: null,
  bSkipSliderHandle: false,
  oCurrentFilters: {},
  iCurrentPageNr: 1,
  iCurrentProductType : '',
  root: null,

  initialize: (useDeeplink, ajaxCallback, Vue = null) => {
    productFilters.oFilterForm = document.forms.filterForm;
    productFilters.aFilterGroups = document.querySelectorAll('.filter-title');
    productFilters.aFilterInputs = document.querySelectorAll('.js-filter-form .checkbox input');
    productFilters.aFilterCheckboxes = document.querySelectorAll('.js-filter-form input[type="checkbox"]');
    productFilters.aFilterSelects = document.querySelectorAll('.js-filter-form select');
    productFilters.aFilterHiddenInputs = document.querySelectorAll('.js-filter-form input[type="hidden"]');
    productFilters.oFilterResults = document.querySelector('.js-filter-results');
    productFilters.aClearFilterButton = document.querySelectorAll('.js-clear-filter');
    productFilters.oClearAllFiltersButton = document.querySelectorAll('.js-clear-all');
    productFilters.oMobileFilterToggles = document.querySelectorAll('.js-toggle-mobile-filters');
    productFilters.oMobileFilters = document.querySelector('.js-mobile-filters');
    productFilters.oMobileFiltersListItems = document.querySelectorAll('.js-filter-list-item');
    productFilters.oMobileFiltersLevelBack = document.querySelectorAll('.js-filters-mobile-back');
    productFilters.oSliders = document.querySelectorAll('.js-price-slider');
    productFilters.oPagingButtons = document.querySelectorAll('.js-pagination-movepage');
    productFilters.oShowAllResultsButton = document.querySelector('.js-pagination-showall');
    productFilters.aProducts = document.querySelectorAll('.product');

    productFilters.root = Vue;

    if (productFilters.oSliders.length) {
      productFilters.createSlider(ajaxCallback);
    }

    [].forEach.call(productFilters.aFilterInputs, (input) => {
      input.addEventListener('change', (e) => {
        productFilters.persistDisabledFilters(e);
      });
    });

    [].forEach.call(productFilters.aFilterCheckboxes, (checkbox) => {
        checkbox.addEventListener('change', (e) => {

            productFilters.changeRelatedCheckbox(checkbox);
            productFilters.filterProducts(e.target);

            if (checkbox.checked) {
                
                var filterwaarde = '';

                var filterwaarde1 = e.target.parentElement.getElementsByTagName('span')[0];
                    
                if (filterwaarde1)
                {
                    filterwaarde = filterwaarde1.getAttribute('data-filter-value');
                }

                if (!filterwaarde)
                {
                    filterwaarde = filterwaarde1.firstChild.nodeValue;
                }

                var filtertype = null;

                var top = e.target.closest(".accordion__item")

                if (top) {
                    filtertype = top.querySelector(".accordion__item__header").innerText;
                } else {
                    top = e.target.closest(".filters__mobile__level")
                    if (top) {
                        filtertype = top.querySelector(".filters__mobile__level__title").innerText;
                    }
                }
   
                if (filtertype && filterwaarde) {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'event': 'kies_productfilter',
                        'filtertype': filtertype,
                        'filterwaarde': filterwaarde.trim()
                    });
                }
            }
        
          });
    });

    [].forEach.call(productFilters.oPagingButtons, (page) => {
      page.addEventListener('click', (e) => {
        e.preventDefault();
        productFilters.filterProducts(e.currentTarget);
      });
    });

    [].forEach.call(productFilters.aFilterSelects, (select) => {
      select.addEventListener('change', (e) => {
        productFilters.filterProducts(e.target);
      });
    });

    [].forEach.call(productFilters.aProducts, (product) => {
      product.addEventListener('click', () => {
        docCookies.setItem('productFiltersScrollTo', `${product.dataset.articlecode}`, '', '/');
      });
    });

    if (productFilters.oShowAllResultsButton !== null) {
      productFilters.oShowAllResultsButton.addEventListener('click', (e) => {
        e.preventDefault();
        productFilters.filterProducts(e.target);
        return false;
      });
    }

    [].forEach.call(productFilters.oClearAllFiltersButton, (button) => {
      button.addEventListener('click', productFilters.clearAllFilters);
    });

    [].forEach.call(productFilters.aClearFilterButton, (button) => {
      button.addEventListener('click', productFilters.clearFilter);
    });

    [].forEach.call(productFilters.oMobileFilterToggles, (toggle) => {
      toggle.addEventListener('click', productFilters.toggleMobileFilters);
    });

    [].forEach.call(productFilters.oMobileFiltersListItems, (item) => {
      item.addEventListener('click', (e) => {
        productFilters.openFilterLevel(item);
      }, false);
    });

    [].forEach.call(productFilters.oMobileFiltersLevelBack, (item) => {
      item.addEventListener('click', (e) => {
        productFilters.closeFilterLevel(e, item);
      });
    });

    // Get Filters from Url, Map them to OverviewFilters Object and preload filters
    if (useDeeplink && window.location.search !== '') {
        const oPreloadOverviewFilters = productFilters.getFiltersFromHash();
        productFilters.loadFiltersFromDeeplink(oPreloadOverviewFilters);
    } else {
      productFilters.removeHiddenClass();
      productFilters.scrollToProduct();
    }

    window.onpopstate = (e) => {
      let oPreloadOverviewFilters;
        oPreloadOverviewFilters = e.state != null ? oPreloadOverviewFilters = e.state : oPreloadOverviewFilters = productFilters.getFiltersFromHash();
        productFilters.loadFiltersFromDeeplink(oPreloadOverviewFilters);

        if (website.body.classList.contains('no-scroll')) {
        website.body.classList.remove('no-scroll');
      }
    };

    productFilters.removeLoadingClass();
  },
  getFiltersFromHash: () => {
    const oPreloadOverviewFilters = productFilters.newOverviewFilters();
    const aFilterTypes = (window.location.search.replace('?', '')).split('&');

    for (let iType = 0; iType < aFilterTypes.length; iType += 1) {
      const aKeyValues = aFilterTypes[iType].split('=');

      if (Array.isArray(oPreloadOverviewFilters[aKeyValues[0]])) {
        oPreloadOverviewFilters[aKeyValues[0]] = aKeyValues[1].split(';');
      } else {
        oPreloadOverviewFilters[aKeyValues[0]] = aKeyValues[1];
      }
    }

    return oPreloadOverviewFilters;
  },
  setInnerHTML: (elm, html) => {
    elm.innerHTML = html;

    Array.from(elm.querySelectorAll("script"))
        .forEach(oldScriptEl => {
            const newScriptEl = document.createElement("script");

            Array.from(oldScriptEl.attributes).forEach(attr => {
                newScriptEl.setAttribute(attr.name, attr.value)
            });

            const scriptText = document.createTextNode(oldScriptEl.innerHTML);
            newScriptEl.appendChild(scriptText);

            oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
        });
  },
  filterProducts: (trigger) => {
      // Set isLoading in App.js
      if (productFilters.root !== null) {
          productFilters.root.isLoading = true;
      }

      var isopen = false;

      var modaloverviewfilter = document.querySelector('.modal--overviewfilter')

      if (modaloverviewfilter && modaloverviewfilter.style.display === 'block' && modaloverviewfilter.style.visibility !== 'hidden') {
          isopen = true;
          modaloverviewfilter.classList.add('is-loading-overviewfilter');
      }

      productFilters.oFilterForm.classList.add('is-loading');
      productFilters.oAjaxTrigger = trigger;

      let formContainer = productFilters.oFilterForm.querySelector('.js-accordion'); // Desktop filters
      const mobileFiltersUsed = (website.iScreenWidth < website.mobileBreakpoint);

      if (mobileFiltersUsed) {
          formContainer = productFilters.oMobileFilters;
      }

      if (productFilters.oAjaxTrigger) {
          if (productFilters.oAjaxTrigger.classList.contains('js-pagination-showall')) {
              productFilters.iCurrentPageNr = 0;
          } else if (productFilters.oAjaxTrigger.classList.contains('js-pagination-movepage') ||
              productFilters.oAjaxTrigger.parentElement.classList.contains('js-pagination-movepage')) {
              const iTriggerPageNr = productFilters.oAjaxTrigger.getAttribute('data-page') ||
                  productFilters.oAjaxTrigger.parentElement.getAttribute('data-page');

              if (iTriggerPageNr !== null) {
                  productFilters.iCurrentPageNr = parseInt(iTriggerPageNr, 10);
              }
          } else {
              productFilters.iCurrentPageNr = 1;
          }
      }

      if (productFilters && productFilters.oAjaxTrigger && productFilters.oAjaxTrigger.id === 'productlist__sort')
      {
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
              'event': 'gebruik_sortering',
              'sorteringkeuze': productFilters.oAjaxTrigger.options[productFilters.oAjaxTrigger.selectedIndex].text
          });
      }

      productFilters.setOverviewFilters(productFilters.newOverviewFilters(),
          formContainer,
          productFilters.iCurrentPageNr);

      var postUrl =
          (`/ProductFilter/OverviewAjax?contentId=${currContentId}&pageNr=${productFilters.iCurrentPageNr}`);

      if (productFilters.iCurrentProductType) {
          postUrl += `&producttype=${productFilters.iCurrentProductType}`;
      }

      fetch(postUrl,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "text/html; charset=UTF-8",
                      "Accept-Language": document.documentElement.lang,
                      "X-Requested-With": "XMLHttpRequest"
                  },
                  body: JSON.stringify(productFilters.oCurrentFilters),
                  credentials: 'same-origin',
              })
          .then(response => response.text())
          .then((response) => {

              productFilters.destroySliders();

              //productFilters.oFilterResults.innerHTML = response;
              productFilters.setInnerHTML(productFilters.oFilterResults, response);

              if (modaloverviewfilter && isopen) {
                  modaloverviewfilter = document.querySelector('.modal--overviewfilter')
                  if (modaloverviewfilter && website.iScreenWidth >= website.mobileBreakpoint) {
                      const myModal = new Modal(modaloverviewfilter);
                      myModal.open(true);
                  }
              }

              fAccordion();
              fInitCustomSelects();
              productFilters.initialize(false, true, productFilters.root);

              if (mobileFiltersUsed) {
                  if (productFilters.oAjaxTrigger) {
                      if (!(productFilters.oAjaxTrigger.classList.contains('js-pagination-showall') ||
                          productFilters.oAjaxTrigger.classList.contains('js-pagination-movepage') ||
                          productFilters.oAjaxTrigger.classList.contains('js-clear-all') ||
                          productFilters.oAjaxTrigger.id === 'productlist__sort')) {
                          productFilters.toggleMobileFilters();
                          const oMobileTrigger = document.getElementById(`${productFilters.oAjaxTrigger.id}`);
                          if (oMobileTrigger)
                          {
                              const oMobileTriggerParent = oMobileTrigger.closest('.js-filter-list-item');
                              if (oMobileTriggerParent)
                              {
                                productFilters.openFilterLevel(oMobileTriggerParent);
                              }
                          }
                      } else {
                          website.body.classList.remove('no-scroll');
                      }
                  }
              }

              setTimeout(() => {
                      productFilters.updateOverviewUrlHash(mobileFiltersUsed, productFilters.iCurrentPageNr);
                      productFilters.scrollToProduct();
                  },
                  0);

              if (productFilters.root !== null) {
                  productFilters.root.isLoading = false;
              }

              productFilters.removeLoadingClass();
              productFilters.removeHiddenClass();
              productFilters.enableFilterWithoutResults();


              if (typeof initFlowBox != "undefined") {
                  setTimeout(() => {
                      initFlowBox();
                  },
                      2000);
              }

          });
  },
  persistDisabledFilters: (event) => {
    const oChk = event.target;
    const oHidClones = productFilters.oFilterForm.querySelectorAll(`#hid${oChk.getAttribute('id')}, #hid${oChk.getAttribute('id')}`); // Find the matching hidden input field

    if (oHidClones) {
      if (oHidClones.length > 1) {
        [].forEach.call(oHidClones, (clone) => {
          clone.value = '';
          if (oChk.checked && oChk.disabled) {
            clone.value = oChk.value;
          }
        });
      } else {
        oHidClones[0].value = ''; // Reset the hidden field first (no value until proven guilty)

        // Only copy the value to the hidden field if its related checkbox is momentarily
        // both checked and disabled, as otherwise it won't be needed
        if (oChk.checked && oChk.disabled) {
          oHidClones[0].value = oChk.value;
        }
      }
    }
  },
  changeRelatedCheckbox: (checkbox) => {
    let relatedCheckbox;
    if (checkbox.id.indexOf('mob-') > -1) {
      const sStrippedCheckboxId = checkbox.id.replace('mob-', '');
      relatedCheckbox = productFilters.oFilterForm.querySelector(`#${sStrippedCheckboxId}`);
    } else {
      relatedCheckbox = productFilters.oFilterForm.querySelector(`#mob-${checkbox.id}`);
    }

    relatedCheckbox.checked = checkbox.checked;
  },
  updateOverviewUrlHash: (mobileFiltersUsed, pageNr) => {
    let formContainer = document.querySelector('.js-accordion');

    if (typeof mobileFiltersUsed === 'undefined') {
      mobileFiltersUsed = false;
    }

    if (mobileFiltersUsed) {
      formContainer = document.querySelector('.js-mobile-filters');
      }

      const oOverviewFilters = productFilters.newOverviewFilters();
      productFilters.setOverviewFilters(oOverviewFilters, formContainer, pageNr);
      
      var sHashUrl = `?${productFilters.getJsonFilterVals(oOverviewFilters)}`;

    if (productFilters.iCurrentProductType) {
      if (sHashUrl !== '?') {
        sHashUrl += `&`;
      }
      sHashUrl += `producttype=${productFilters.iCurrentProductType}`;
    }

    if (window.location.search !== sHashUrl) {
      if (sHashUrl !== '?') {

        window.history.replaceState(undefined, undefined, sHashUrl);

        //window.history.pushState(oOverviewFilters, 'deeplink', sHashUrl);
      } else {
          window.history.replaceState(oOverviewFilters, 'initialState', window.location.pathname );
      }
    }

  },
  newOverviewFilters: () => {
    const oFilters = {
        page: 1,
        sort: ''
    };

    var filters = document.getElementsByClassName('filters');
    if (filters) {
        var dataset = filters[0].dataset.filters;
        if (dataset) {
            dataset.split(';').forEach(tag => {
                oFilters[tag] = [];
            });
        }
    }

    return oFilters;
  },
  setOverviewFilters: (oFilters, oForm, pageNr) => {
    const oFields = Array.prototype.slice.call(oForm.querySelectorAll('.js-filter-form input[type="checkbox"]:checked'));
    const oSelects = Array.prototype.slice.call(document.querySelectorAll('.js-filter-form select'));

    oFields.push(...oSelects);

    for (let i = 0; i < oFields.length; i += 1) {
      const oField = oFields[i];
      const sFilterType = oField.getAttribute('name');
      const sFilterVal = oField.value;

      if (oField.type === 'checkbox') {
        oFilters[sFilterType].push(sFilterVal);
      } else {
        oFilters[sFilterType] = sFilterVal;
      }
    }

      [].forEach.call(oForm.querySelectorAll('.js-price-slider-selected-max'),
          max => {
              var parent = max.parentElement;
              var min = parent.querySelector('.js-price-slider-selected-min');
              var minDefault = parent.querySelector('.js-price-slider-min');
              var maxDefault = parent.querySelector('.js-price-slider-max');

              if (max.value !== maxDefault.value || min.value !== minDefault.value) {
                  oFilters[min.getAttribute('name')] = min.value;
                  oFilters[max.getAttribute('name')] = max.value;

                  oFilters[minDefault.getAttribute('name')] = minDefault.value;
                  oFilters[maxDefault.getAttribute('name')] = maxDefault.value;

              } else {
                  delete oFilters[min.getAttribute('name')];
                  delete oFilters[max.getAttribute('name')];

                  delete oFilters[minDefault.getAttribute('name')];
                  delete oFilters[maxDefault.getAttribute('name')];

              }
          });


    oFilters.page = pageNr;
    productFilters.iCurrentPageNr = pageNr;

    productFilters.oCurrentFilters = oFilters;
  },
  getJsonFilterVals: (oAppliedFilters) => {
    let sHash = '';
    let sPrevArrFilter = '';
    const oAppliedFiltersKeys = Object.keys(oAppliedFilters);

    const defaultFilters = productFilters.newOverviewFilters();
      
    if (JSON.stringify(defaultFilters) !== JSON.stringify(oAppliedFilters)) {
      oAppliedFiltersKeys.forEach((filterType) => {
        if (Array.isArray(oAppliedFilters[filterType])) {
          oAppliedFilters[filterType] = oAppliedFilters[filterType].filter((v, i) => oAppliedFilters[filterType].indexOf(v) === i);

          if (oAppliedFilters[filterType].length > 0) {
            const aFilterVals = oAppliedFilters[filterType];

            if (sHash === '') {
              sHash = `${filterType}=${oAppliedFilters[filterType][0]}`;
            } else if ((sHash !== '') && (sPrevArrFilter !== filterType)) {
              sHash += `&${filterType}=${oAppliedFilters[filterType][0]}`;
            }

            for (let iFilter = 0; iFilter < aFilterVals.length; iFilter += 1) {
              if (iFilter > 0) {
                sHash += `;${aFilterVals[iFilter]}`;
              }
            }
            sPrevArrFilter = filterType;
          }
        } else {

          if (filterType === 'page' && oAppliedFilters[filterType] === 1) {
             return;
          }
          else if (filterType !== 'page' && oAppliedFilters[filterType].length === 0) {
             return;
          }
          else if (sHash !== '') {
             sHash += '&';
          }

          sHash += `${filterType}=${oAppliedFilters[filterType]}`;
        }
      });
    }

    return sHash;
  },
  loadFiltersFromDeeplink: (oPreloadOverviewFilters) => {
    const oPreloadOverviewFiltersKeys = oPreloadOverviewFilters !== null
      ? Object.keys(oPreloadOverviewFilters)
      : Object.keys(productFilters.newOverviewFilters());

    // Disable all filters
    [].forEach.call(productFilters.aFilterHiddenInputs, (input) => {
      const oInput = input;
      if (oInput.nextElementSibling !== null && oInput.nextElementSibling.type === 'checkbox') {
        oInput.value = '';
      }
    });

    [].forEach.call(productFilters.aFilterCheckboxes, (checkbox) => {
      const oCheckbox = checkbox;
      oCheckbox.checked = false;
    });
      
    if (oPreloadOverviewFilters !== null) {
      oPreloadOverviewFiltersKeys.forEach((filterType) => {
        if (oPreloadOverviewFilters !== null && Array.isArray(oPreloadOverviewFilters[filterType])) {
            if (oPreloadOverviewFilters[filterType].length > 0) {
                const aFilterValues = oPreloadOverviewFilters[filterType];
              for (let iFilter = 0; iFilter < aFilterValues.length; iFilter += 1) {
              productFilters.selectCheckbox(aFilterValues[iFilter], filterType);
              productFilters.setHiddenInputValues(aFilterValues[iFilter], filterType);
            }
          }
        } else {
          const filterValue = oPreloadOverviewFilters[filterType];
          productFilters.setHiddenInputValues(filterValue, filterType);
        }
      });
    }

    if (oPreloadOverviewFilters !== null) {
      productFilters.iCurrentPageNr = parseInt(oPreloadOverviewFilters.page, 10);
    }

    if (oPreloadOverviewFilters.producttype) {
        productFilters.iCurrentProductType = oPreloadOverviewFilters.producttype;
    }

    productFilters.filterProducts(null);
  },
  clearFilter: (e) => {
    const sFilterValue = e.target.getAttribute('data-filter-value');
    const sFilterType = e.target.getAttribute('data-filter-type');

    if (sFilterType === 'checkbox') {
        const sFilterKey = e.target.getAttribute('data-filter-key');
        productFilters.selectCheckbox(sFilterValue, sFilterKey, true);
    } else {
        productFilters.resetSliders(sFilterType);
    }

    productFilters.filterProducts(e.target);
    e.preventDefault();
  },
  clearAllFilters: (e) => {
    [].forEach.call(productFilters.aFilterCheckboxes, (checkbox) => {
      const oCheckbox = checkbox;
      oCheckbox.checked = false;
    });

    productFilters.resetSliders();
    productFilters.filterProducts(e.target);
    e.preventDefault();
  },
  selectCheckbox: (value, type, clear = false) => {
      [].forEach.call(productFilters.aFilterCheckboxes, (checkbox) => {
        const sInputName = checkbox.getAttribute('name');
        const oCheckbox = checkbox;
        if (sInputName === type && oCheckbox.value === value) {
        oCheckbox.checked = !clear;
      }
    });
  },
  setHiddenInputValues: (value, type) => {
    [].forEach.call(productFilters.aFilterHiddenInputs, (input) => {
      const oInput = input;
      const sInputName = oInput.getAttribute('name');

      if (type.indexOf("min") === 0 && sInputName === type) {
        productFilters.setSliderValues(input, value, null);
      } else if (type.indexOf("max") === 0 && sInputName === type) {
        productFilters.setSliderValues(input, null, value);
      } else if (oInput.id === `hid${type + value}`) {
        oInput.value = value;
      }
    });

    [].forEach.call(productFilters.aFilterSelects, (select) => {
      if (select.getAttribute('name') === type) {
        select.value = value;
      }
    });
  },
  createSlider: (ajaxCallback) => {
      [].forEach.call(productFilters.oSliders, (slider) => {
        const oSlider = slider.querySelector('.range-slider__slider');

      const maxValue = parseFloat(slider.querySelector('.js-price-slider-max').value, 10);
      const minValue = parseFloat(slider.querySelector('.js-price-slider-min').value, 10);

      const selectedActualMinValue = slider.querySelector('.js-price-slider-selected-min');
      const selectedActualMaxValue = slider.querySelector('.js-price-slider-selected-max');
      const selectedSliderText = slider.querySelector('.js-selected-price-range');
      const selectedSliderTextMin = selectedSliderText.querySelector('.js-selected-price-range-min');
      const selectedSliderTextMax = selectedSliderText.querySelector('.js-selected-price-range-max');

      var hostLanguage = document.documentElement.lang;

      const step = 1;
      var margin = Math.ceil((maxValue - minValue) / (11 * step)) * step

      const oOptions = {
          start: [selectedActualMinValue.value, selectedActualMaxValue.value],
        range: {
            min: [minValue],
            max: [maxValue],
        },
        //behaviour: 'drag',
        connect: true,
        margin: margin,
        //step: step,
        cssPrefix: 'hbf-',
        format: {
          to: value => `${Math.round(value)}`,
          from: value => value,
        },
        tooltips: [
          {
              to: value => `${Math.round(value)}`,
              from: value => value,
          },
          {
            to: value => `${Math.round(value)}`,
            from: value => value,
          },
        ]
      };

      noUiSlider.create(oSlider, oOptions);

      oSlider.noUiSlider.on('update', (values, handle) => {
        if (!productFilters.bSkipSliderHandle) { // Prevents the AJAX call from being called for both handles each time one is moved
          const handleTooltips = oSlider.querySelectorAll('.hbf-handle .hbf-tooltip');

          selectedSliderTextMin.textContent = `${handleTooltips.item(0).innerHTML}`;
          selectedSliderTextMax.textContent = `${handleTooltips.item(1).innerHTML}`;
          selectedActualMinValue.value = values[0].replace('€', '');
          selectedActualMaxValue.value = values[1].replace('€', '');

          productFilters.bSkipSliderHandle = true;
        } else {
          productFilters.bSkipSliderHandle = false;
        }
      });

      oSlider.noUiSlider.on('end', (values, handle, unencoded, tap, positions) => {
        const min = Math.round(unencoded[0]).toString();
        const max = Math.round(unencoded[1]).toString();

        const maxV = parseInt(slider.querySelector('.js-price-slider-max').value, 10);
        const minV = parseInt(slider.querySelector('.js-price-slider-min').value, 10);

        if (minV !== min || maxV !== max) {
          productFilters.filterProducts(oSlider.parentElement);
        }
      });

      productFilters.aCreatedSliders.push(oSlider);
    });
  },
  resetSliders: (sFilterType) => {
      [].forEach.call(productFilters.aCreatedSliders, (slider) => {

          if (typeof sFilterType === 'undefined' || slider.noUiSlider.target.parentElement.id.includes(sFilterType)) {

              // Reset slider only if current values dont match the starting values
              const aStartingSliderValues = [];
              aStartingSliderValues.push(slider.noUiSlider.options.range.min[0], slider.noUiSlider.options.range.max[0]);

              const aCurrentSliderValuesStripped = [];
              const aCurrentSliderValues = slider.noUiSlider.get();
              [].forEach.call(aCurrentSliderValues, (value) => {
                      aCurrentSliderValuesStripped.push(parseFloat(value.replace('€', '')));
                  });

              if (JSON.stringify(aStartingSliderValues) !== JSON.stringify(aCurrentSliderValuesStripped)) {
                  slider.noUiSlider.set(aStartingSliderValues);
              }
          }
      });
  },
  destroySliders: () => {
    [].forEach.call(productFilters.oSliders, (slider) => {
      if (typeof slider.noUiSlider === 'object') {
        slider.noUiSlider.destroy();
      }
      productFilters.aCreatedSliders.splice(0, 1);
    });
    },
    setSliderValues: (input, min, max) => {
        [].forEach.call(productFilters.aCreatedSliders, (slider) => {
            if (slider.noUiSlider.target.parentElement === input.parentElement) {
              slider.noUiSlider.set([min, max]);
          }
      });
  },
  toggleMobileFilters: (event) => {
    if (productFilters.oMobileFilters.classList.contains('filters__mobile--active')) {
      productFilters.oMobileFilters.classList.remove('filters__mobile--active');
      website.body.classList.remove('no-scroll');
    } else {
      productFilters.oMobileFilters.classList.remove('d-none');
      productFilters.oMobileFilters.classList.add('d-flex');
      productFilters.oMobileFilters.classList.add('filters__mobile--active');

      if (!website.body.classList.contains('no-scroll')) {
        website.body.classList.add('no-scroll');
      }
    }

    if (event) {
      event.preventDefault();
    }
  },
  openFilterLevel: (item) => {
    const oCurrentFilterSubLevel = item.querySelector('.filters__mobile__level');
    oCurrentFilterSubLevel.classList.add('filters__mobile__level--active');
  },
  closeFilterLevel: (event, item) => {
    const oLevel = item.closest('.filters__mobile__level--active');
    if (oLevel) {
      oLevel.classList.remove('filters__mobile__level--active');
    }

    event.stopPropagation();
  },
  scrollToProduct: () => {
    if (docCookies.getItem('productFiltersScrollTo') !== null && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
      const oProductToScrollTo = document.querySelector(`[data-articlecode="${docCookies.getItem('productFiltersScrollTo')}"]`) ? document.querySelector(`[data-articlecode="${docCookies.getItem('productFiltersScrollTo')}"]`).parentElement : null;
      if (oProductToScrollTo) {
        imagesLoaded(productFilters.oFilterForm, () => {
          scrollIt(oProductToScrollTo, 0);
          docCookies.removeItem('productFiltersScrollTo', '/', '');
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  },
  removeHiddenClass: () => {
    if (productFilters.oFilterForm.classList.contains('is-hidden')) {
      productFilters.oFilterForm.classList.remove('is-hidden');
    }
  },
  removeLoadingClass: () => {
    if (productFilters.oFilterForm.classList.contains('is-loading')) {
      productFilters.oFilterForm.classList.remove('is-loading');
    }
  },
  enableFilterWithoutResults: () => {
    // Check for checkboxes that are checked and disabled
    productFilters.aFilterCheckboxes.forEach((checkbox) => {
      if ((checkbox.checked && checkbox.disabled) && checkbox.parentElement.querySelector('.filter__count').textContent === '0') {
        checkbox.disabled = false;
      }
    });
  },
};
